import React, { useCallback } from 'react';
import { Divider, Grid, Box } from '@material-ui/core';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import {
    getTotalExtendedPriceRP,
    priceFormatObj,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import Button from '@material-ui/core/Button';
import { isMobileView, setCurrencyFormat } from 'src/utils/util.js';
import { sizes } from 'src/styles/Media.styled';
import styled from 'styled-components';
import {
    noPriceErrorMsg,
    getPriceInNumberDataType,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { useTranslation } from 'react-i18next';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';

const ItemPricesRPMobile = ({
    item,
    displayPrice,
    isFromMobileView,
    isBundleItem,
    index,
    showBundlefromTableList,
    isChildItem,
    isFromReportScreen,
    checkNewAddedProduct,
    deleteItem,
    winWidth,
    lotSerialValueEntered,
}) => {
    const { t } = useTranslation();
    const adjQtyLabel = useAdjQtyLabel();
    const getUsedAndOtherQuantity = useCallback(
        (item) => {
            const qtyObj = { usedQty: null, otherQty: null };
            // Split read-only rows carry exactly one qty-type; use splitQtyType so a
            // used-side qty of `false`/0 quirk can never suppress the used row (which
            // otherwise showed "only other").
            if (item.isSplitLotSerialItem) {
                // Split rows carry exactly one qty-type. Prefer the item-level
                // qty, but fall back to the single lotSerial entry's qty so the
                // read-only box never renders empty if the item-level value is
                // ever missing after a pricing/validation round-trip.
                const splitLot = item.lotSerial?.[0];
                if (item.splitQtyType === 'used') {
                    qtyObj.usedQty = ![null, undefined, '', false].includes(
                        item.usedQuantity
                    )
                        ? item.usedQuantity
                        : splitLot?.Used ?? splitLot?.used;
                } else if (item.splitQtyType === 'other') {
                    qtyObj.otherQty = ![null, undefined, '', false].includes(
                        item.otherQuantity
                    )
                        ? item.otherQuantity
                        : splitLot?.Other ?? splitLot?.other;
                }
                return qtyObj;
            }
            if (
                item.otherQuantity === null ||
                item.otherQuantity === undefined
            ) {
                qtyObj.usedQty = item.usedQuantity;
                qtyObj.otherQty = null;
            } else if (
                item.usedQuantity === null ||
                item.usedQuantity === undefined
            ) {
                qtyObj.usedQty = null;
                qtyObj.otherQty = item.otherQuantity;
            }
            return qtyObj;
        },
        [item]
    );

    const itemContainer = (item, isUsed) => (
        <>
            <Grid item xs={4} sm={2}>
                <StyledTextDiv
                    width={isFromMobileView && '110px'}
                    minWidth={'110px'}
                >
                    {isChildItem ? (
                        `${t(
                            'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                        )}: ${item.quantity}`
                    ) : item.isSplitLotSerialItem ? (
                        // Split items show qty in LotSerialRPQtyInputMobile, so just show label here
                        item.unitPrice && (
                            <SplitQtyContainer>
                                <span>
                                    {isUsed
                                        ? t(
                                              'reportUsage.record.itemsList.QuantityInputBoxes.used'
                                          )
                                        : t(adjQtyLabel('reportUsage.itemList.other'))}
                                </span>
                                {/* removing this input box as need to show just readable text */}
                                {/* <TextWithInputs
                                    name={
                                        isUsed
                                            ? t('reportUsage.itemList.used')
                                            : t('reportUsage.itemList.other')
                                    }
                                    placeholder={t(
                                        'reportUsage.replen.replenListView.qty'
                                    )}
                                    onkeyUp={(e) =>
                                        lotSerialValueEntered(
                                            e,
                                            item,
                                            index,
                                            item.lotSerial?.[0],
                                            0
                                        )
                                    }
                                    value={
                                        isUsed
                                            ? item.lotSerial?.[0]?.Used ||
                                              (item.lotSerial?.[0]?.used ===
                                              false
                                                  ? ''
                                                  : item.lotSerial?.[0]?.used)
                                            : item.lotSerial?.[0]?.Other ||
                                              item.lotSerial?.[0]?.other
                                    }
                                    maxLength={2}
                                    inputHeight={'42px'}
                                    inputWidth={'48px'}
                                    alignText={'center'}
                                    inputBorder={
                                        item.lotSerial?.[0]?.isInvalidQtyMsg
                                            ?.length > 0 &&
                                        '2px solid #FACFD6'
                                    }
                                /> */}
                                <QuantityBox>
                                    {isUsed
                                        ? item.lotSerial?.[0]?.Used ||
                                          (item.lotSerial?.[0]?.used === false ? '' : item.lotSerial?.[0]?.used) ||
                                          item.usedQuantity
                                        : item.lotSerial?.[0]?.Other ||
                                          item.lotSerial?.[0]?.other ||
                                          item.otherQuantity}
                                </QuantityBox>
                            </SplitQtyContainer>
                        )
                    ) : (
                        <>
                            {![null, undefined, '', false].includes(
                                isUsed
                                    ? getUsedAndOtherQuantity(item).usedQty
                                    : getUsedAndOtherQuantity(item).otherQty
                            ) &&
                                item.unitPrice &&
                                `${isBundleItem
                                    ? t(
                                        'reportUsage.record.itemsList.QuantityInputBoxes.used'
                                    )
                                    : isUsed
                                        ? t(
                                            'reportUsage.record.itemsList.QuantityInputBoxes.used'
                                        )
                                        : t(adjQtyLabel('reportUsage.itemList.other'))
                                }`}
                            {item.unitPrice && (
                                <QuantityBox>
                                    {isUsed
                                        ? getUsedAndOtherQuantity(item)
                                            .usedQty === true
                                            ? 1
                                            : getUsedAndOtherQuantity(item)
                                                .usedQty
                                        : getUsedAndOtherQuantity(item)
                                            .otherQty === true
                                            ? 1
                                            : getUsedAndOtherQuantity(item)
                                                .otherQty}
                                </QuantityBox>
                            )}
                        </>
                    )}
                </StyledTextDiv>
            </Grid>
            {/* Delete Icon Block - moved here */}
            {isFromReportScreen &&
                !checkNewAddedProduct && (<Grid
                    item
                    xs={2}
                >
                    <Box
                     id={`reportUsage-reportPayment-mobile-item-delete-button-${index}`}
                        component={Button}
                        aria-controls="simple-menu-1"
                        aria-hospopup="true"
                        size="small"
                        width={'32px'}
                        height={'32px'}
                        minWidth={'32px !important'}
                        minHeight={'32px'}
                        border="1px solid #EBEBEB"
                        borderRadius={6}
                        onClick={() =>
                            deleteItem(
                                index,
                                0,
                                null,
                                item
                            )
                        }
                    >
                        <img
                            src={DeleteLight}
                            style={{
                                width: 20,
                                height: 20,
                            }}
                        />
                    </Box>
                </Grid>)}
            {displayPrice && (
                <>
            <Grid
                item
                xs={3}
                sm={3}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                }}
            >
                <Box
                    style={{
                        fontFamily: 'AvenirNextWorld Demi',
                        fontSize: '13px',
                    }}
                >
                    {t(
                        'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.unitPrice'
                    )}
                </Box>
                <DiscountedPriceTemplate
                    isPriceNotAvailable={
                        (!item.accountOwned || !item.isAccountOwned) &&
                        (item.isPriceNotAvailable ||
                            item.exclusionStatus === noPriceErrorMsg)
                    }
                    originalPrice={
                        getPriceInNumberDataType(item.unitPrice) >= 0 &&
                        setCurrencyFormat(item.unitPrice)
                    }
                    adjustedPrice={!item.accountOwned && item.overrideUnitPrice}
                    modifiedPrice={
                        item.accountOwned
                            ? setCurrencyFormat(0)
                            : getPriceInNumberDataType(
                                item.overrideUnitPrice
                            ) >= 0
                                ? setCurrencyFormat(item.overrideUnitPrice)
                                : getPriceInNumberDataType(item.unitPrice) >= 0 &&
                                setCurrencyFormat(item.unitPrice)
                    }
                />
            </Grid>
            <Grid
                item
                xs={5}
                sm={3}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                }}
            >
                <Box
                    style={{
                        fontFamily: 'AvenirNextWorld Demi',
                        fontSize: '13px',
                    }}
                >
                    {t('reportUsage.record.reportPaymentTable.extPrice')}
                </Box>
                <DiscountedPriceTemplate
                    isPriceNotAvailable={
                        (!item.accountOwned || !item.isAccountOwned) &&
                        (item.isPriceNotAvailable ||
                            item.exclusionStatus === noPriceErrorMsg)
                    }
                    originalPrice={getTotalExtendedPriceRP(
                        item.unitPrice,
                        isUsed ? item.usedQuantity : item.otherQuantity,
                        isUsed ? 'used' : 'other'
                    )}
                    adjustedPrice={!item.accountOwned && item.overrideUnitPrice}
                    modifiedPrice={
                        item.accountOwned
                            ? setCurrencyFormat(0)
                            : getTotalExtendedPriceRP(
                                item.overrideUnitPrice
                                    ? item.overrideUnitPrice
                                    : item.unitPrice,
                                isUsed
                                    ? item.usedQuantity
                                    : item.otherQuantity,
                                isUsed ? 'used' : 'other'
                            )
                    }
                />
            </Grid>
                </>
            )}
            {/* {winWidth > sizes.mobileDevice &&
                winWidth <= sizes.smalDevice &&
                isFromReportScreen &&
                item.unitPrice && (
                    <Grid item xs={4} sm={1}>
                        <Box
                            component={Button}
                            aria-controls="simple-menu-1"
                            aria-hospopup="true"
                            size="small"
                            width={'40px'}
                            height={'40px'}
                            minWidth={'40px !important'}
                            minHeight={'40px'}
                            border="1px solid #EBEBEB"
                            borderRadius={6}
                            onClick={() => deleteItem(index, 0)}
                        >
                            <img
                                src={DeleteLight}
                                style={{
                                    width: 20,
                                    height: 20,
                                }}
                            />
                        </Box>
                    </Grid>
                )} */}
        </>
    );

    return (
        <ItemPriceContainer
            justifyContent={!isMobileView() && 'space-around'}
            marginTop={winWidth <= sizes.mobileDevice && '7px'}
        >
            {isBundleItem && isFromMobileView && (
                <CustomLabel
                id={`reportUsage-reportPayment-mobile-addItems-label-${index}`}
                    fSize={'12px !important'}
                    color="#1010EB"
                    cursor={'pointer'}
                    opacity={1}
                    label={t(
                        'reportUsage.record.reportPayment.ItemList.ReportPaymentItemListMobile.addItems'
                    )}
                    onLabelClick={() =>
                        showBundlefromTableList(true, index, item.productCFN,item?.unqId)
                    }
                    width={'77px'}
                    letterSpacing={'-0.11px'}
                />
            )}
            {item.unitPrice && !isChildItem && (
                <>
                    {(displayPrice || item.isSplitLotSerialItem) &&
                        getUsedAndOtherQuantity(item).usedQty !== null &&
                        itemContainer(item, true)}
                    {getUsedAndOtherQuantity(item).usedQty !== null &&
                        getUsedAndOtherQuantity(item).otherQty !== null && (
                            <DividerContainer>
                                <Divider orientation="horizontal" />
                            </DividerContainer>
                        )}
                    {(displayPrice || item.isSplitLotSerialItem) &&
                        getUsedAndOtherQuantity(item).otherQty !== null &&
                        itemContainer(item, false)}
                </>
            )}
        </ItemPriceContainer>
    );
};

export default ItemPricesRPMobile;

export const DividerContainer = styled.div`
    padding: 8px 0px;
`;

export const ItemPriceContainer = styled.div`
    display: flex;
    justify-content: ${({ justifyContent }) => justifyContent};
    margin-top: ${({ marginTop }) => marginTop};
`;

export const QuantityBox = styled.div`
    paddingLeft: 12px;
    fontFamily: AvenirNextWorld Regular,
    fontSize: 14px,
`;

export const SplitQtyContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
